import React from "react";
import "./about.css";
import whiteWaves from "../../media/images/whiteWaves.png";

const About = () => {
    return (
        <section id="about">
            <div>
                <h1 data-aos="fade-up" className="head">
                    קצת אלינו
                </h1>
                <p data-aos="fade-up" className="p">
                    בתים וגנים חברת עבודות ועיצובים. בברזל אלומניום ועץ. ליווי
                    וייעוץ בכול שלב בתהליך. מגיעים לבית הלקוח תחילה לייעוץ בהמשך
                    תכנון סרטוט והדמיה, משתמשים בחומר הגלם האיכותי ביותר ולבסוף
                    התקנה ובניה של המוצר במהירות ובטיחות. תוכלו להרגיש בטוחים
                    בידיים שלנו ולראות איך לאט לאט מה שרציתם נבנה מול עינייכם.
                    ענו מתחייבים לאיכות הגבוהה ביותר , בניה שמתחשב בפרטים הקטנים
                    בצורה מדויקת וללא התפשרות, והתקנה שקטה ומהירה. צרו אתנו קשר
                    עוד היום, לתיאום יועץ שיתחיל איתכם את התהליך לשדרוג הבית
                </p>
            </div>
            <a href="#contact" className="animated-button">
                <svg
                    viewBox="0 0 24 24"
                    className="arr-2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
                <span className="text">לתיאום יועץ</span>
                <span className="circle"></span>
                <svg
                    viewBox="0 0 24 24"
                    className="arr-1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
            </a>

            <img src={whiteWaves} alt="White waves" />
        </section>
    );
};

export default About;
